export default __webpack_public_path__ + "static/media/sanko-enerji-logo.afac45b6.svg";